import { Notification } from 'element-ui';
import './notification.scss';

export default function notification(Vue) {
  Vue.prototype.$notify = Notification;
}
